<template>

<v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" LeadsPannel>
            <v-row>
              <v-col cols="12" LEADSPANEL>
                <v-card :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">slideshow</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n['slider_settings'] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                        <Paging
                          :resourceSettings="resourceSettings" 
                          :resource="resource"
                          @loadResource="loadResource"
                          @pageByNumber="pageByNumber"
													@createResource="dialog = true"
                        />
                      </v-col>

											<v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-1 my-0`" v-for="(d, i) in resource.data" :key="i+'not'">
                        <v-row class="align-center elevation-2">
                          <v-col cols="8" :class="`${arabic?'arFont':'enFont'}`">
                            <div>
                              <img :src="d.image" height="100px">
                            </div>
                          </v-col>
                          <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                            <v-btn color="blue" text @click="editSlide(d)">{{ i18n.edit }}</v-btn>
                          </v-col>
                          <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                            <v-btn color="error" text @click="deleteSlide(d.id)">{{ i18n.delete }}</v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

		<MultiDialog 
      :dialog="dialog"
      :resourceKeys="resourceKeys"
      :resourceSettings="resourceSettings"
      :newResource="newResource"
      @closeDialog="closeDialog"
      @postResource="postResource"
      @updateResource="updateResource"
      @getUpload="getUpload"
		/>

  </v-container>

</template>

<script>
import Paging from '@/components/Paging.vue';
import MultiDialog from '../components/multiDialog.vue';

export default {
	components: { Paging, MultiDialog },
	data() {
		const lang = this.$store.state.language

		const devices = [
			{ text: this.$store.state.i18n[lang].desktop, device_id: "desktop"},
			{ text: this.$store.state.i18n[lang].mobile, device_id: "mobile"},
		]
		return {
			dialog: false,
			loading: false,
      resourceSettings:{
        resourceName: "slides",
        search:false,
        create:false,
        pagination:true,
				createResource: true
      },
			resource: {},
			newResource: {},
			resourceKeys: [
				{ name: 'image', label: 'image', type: 'upload', required: false, readonly: false, info: {en: '', ar: ''} },
				{ name: 'order', label: 'order', type: 'number', fetched: 'order', required: true, readonly: false },
        { name: 'device', label: 'device', type: 'select', data: devices, required: true, readonly: false },
			]
		};
	},
	methods: {
    async deleteSlide(id) {
      this.loading = true
      let a = await this.$store.dispatch('deleteResource', {resource:`/slides/${id}`}) 
      await this.loadResource()
      this.loading = false
    },
		editSlide(resource) {
      this.newResource = {...resource}
      this.dialog = true 
		},
		async updateResource(resource) {
      this.loading = true;

      await this.$store.dispatch('putResource', {
        resource: `/slides/${resource.id}`,
        value: resource,
      });

      this.newResource = {};
      this.dialog = false;
			this.loading = false

      await this.loadResource();
		},
    async postResource(resource = null) {
      this.loading = true;
      const settings = resource ? resource : this.newResource;

      await this.$store.dispatch('postResource', {
        resource: "/slides",
        value: settings,
      });

      await this.loadResource();

      this.newResource = {};
      this.dialog = false;
      this.loading = false;
    },
		closeDialog() {
			this.dialog = false
		},
    getUpload({field, value}) {
      this.newResource[field] = value 
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
				this.resource = await this.$store.dispatch('getResource', {resource:'/slides'})
        this.loading = false
        res()
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
				this.resource = await this.$store.dispatch('getResource', {resource: '/slides', page:`?page=${n}`})
        this.loading = false
      })
    },
	},
	computed:{
    endpoint() {
      return {
        'articles': '/help/articles',
        'categories': '/help/categories',
        'keywords': '/help/keywords',
      }[this.section]
    },
    countries(){
      return this.$store.state.countries
    },
    statuses_obj(){
      return this.$store.state.statuses_obj
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
	async mounted() {
		await this.loadResource()
	}
}
</script>